var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{staticClass:"overflow-hidden",attrs:{"full-bleed":""}},[_c('div',{staticClass:"flex flex-col"},[_c('TrainingRegistrationHeader'),_vm._v(" "),_c('div',{staticClass:"p-8 pb-12"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }